import { Dispatch } from 'redux';

import { KonsiergeMessage } from '../models/KonsiergeMessage';
import { SOCKET } from '../middlerware/socket';
import { isArray } from 'util';
import { fetcher } from '../lib/request';

export const RECEIVE_MESSAGE = 'RECEIVE_MESSAGE';

export const REQUEST_MESSAGE_SEND = 'REQUEST_MESSAGE_SEND';
export const RESPONSE_MESSAGE_SEND = 'RESPONSE_MESSAGE_SEND';
export const ERROR_MESSAGE_SEND = 'ERROR_MESSAGE_SEND';

export const REQUEST_FILE_SEND = 'REQUEST_FILE_SEND';
export const RESPONSE_FILE_SEND = 'RESPONSE_FILE_SEND';
export const ERROR_FILE_SEND = 'ERROR_FILE_SEND';

export const SEEN_MESSAGE = 'SEEN_MESSAGE';
export const MESSAGE_SEEN = 'MESSAGE_SEEN';
export const MESSAGE_SEEN_ERROR = 'MESSAGE_SEEN_ERROR';

export const OPERATOR_TYPING = 'OPERATOR_TYPING';
export const MESSAGES_VIEWED_BY_OPERATOR = 'MESSAGES_VIEWED_BY_OPERATOR';
export const MESSAGE_UPDATE = 'MESSAGE_UPDATE';

export const REQUEST_HISTORY = 'REQUEST_HISTORY';
export const RECEIVE_HISTORY = 'RECEIVE_HISTORY';
export const ERROR_HISTORY = 'ERROR_HISTORY';

export const REQUEST_CLIENT_TYPING = 'REQUEST_CLIENT_TYPING';
export const RESPONSE_CLIENT_TYPING = 'RESPONSE_CLIENT_TYPING';
export const ERROR_CLIENT_TYPING = 'ERROR_CLIENT_TYPING';

export const REQUEST_GET_COUNTERS = 'REQUEST_GET_COUNTERS';
export const RESPONSE_GET_COUNTERS = 'RESPONSE_GET_COUNTERS';
export const ERROR_GET_COUNTERS = 'ERROR_GET_COUNTERS';

const CHAT_HOST = process.env.REACT_APP_SOCKET_HOST;
const CHAT_KEY = process.env.REACT_APP_CHAT_KEY;

export const receiveMessage = (message: KonsiergeMessage) => ({
    type: RECEIVE_MESSAGE,
    message,
});

export const operatorTyping = () => ({
    type: OPERATOR_TYPING,
});

export const onMessagesViewed = (discussion_type_id: number) => ({
    type: MESSAGES_VIEWED_BY_OPERATOR,
    discussion_type_id,
});

export const onMessageUpdate = (message: KonsiergeMessage) => ({
    type: MESSAGE_UPDATE,
    message,
});

function createFormData(data: any, hash: string): FormData {
    const formData = new FormData();
    Object.keys(data).forEach(field => {
        const value = (data as any)[field];
        if (isArray(value)) {
            value.forEach(v => formData.append(`files[${hash}]`, v));
        }
        if (value !== undefined && value !== null && !isArray(value)) {
            formData.append(field, value);
        }
    });
    return formData;
}

export const sendFileAction = (discussionId: number, discussionTypeId: number, userId: string, attachments: File[], hash: string) => async (dispatch: Dispatch<any>) => {
    dispatch({
        type: REQUEST_FILE_SEND,
    });

    try {
        const body = {
            discussion_id: discussionId,
            discussion_type_id: discussionTypeId,
            client_id: userId,
            client_version: 7,
            attachments,
        };
        const authString: any = localStorage.getItem('auth');
        const auth: any = JSON.parse(authString);

        const response = await fetcher(`${process.env.REACT_APP_SOCKET_HOST}/v1/upload`)
            .post(createFormData(body, hash))
            .auth(`Bearer ${auth.access_token}`)
            .json();

        dispatch({
            type: RESPONSE_FILE_SEND,
            response,
        });
    } catch (error) {
        dispatch({
            type: ERROR_FILE_SEND,
            error,
        });
    }
};

export const sendMessageAction = (content: string, hash: string, discussion_type_id: number, discussion_id: number, reply_for: string | null = null) => (dispatch: Dispatch<any>) => {
    const params: any = {
        content: content,
        hash: hash,
        discussion_id: discussion_id,
        discussion_type_id: discussion_type_id,
    };
    dispatch({
        type: REQUEST_MESSAGE_SEND,
        content,
        hash,
        discussion_type_id,
    });

    return dispatch({
        type: REQUEST_MESSAGE_SEND,
        [SOCKET]: {
            type: 'EMIT',
            event: 'message',
            data: [params],
            attached: {content, hash, discussion_id, discussion_type_id},
            successType: RESPONSE_MESSAGE_SEND,
            errorType: ERROR_MESSAGE_SEND,
        },
    });
};

export const seenMessageAction = (discussion_type_id: number, discussionId: number) => (dispatch: Dispatch<any>) => {
    const params: any = {
    };
    params.discussion_type_id = discussion_type_id;
    dispatch({
        type: SEEN_MESSAGE,
        discussion_type_id,
        discussionId
    });

    return dispatch({
        type: SEEN_MESSAGE,
        [SOCKET]: {
            type: 'EMIT',
            event: 'messages_seen',
            data: [params],
            attached: {
                discussion_type_id
            },
            successType: MESSAGE_SEEN,
            errorType: MESSAGE_SEEN_ERROR,
        }
    });
};

export const typingClientAction = (discussion_type_id?: number) => (dispatch: Dispatch<any>) => {
    dispatch({
        type: REQUEST_CLIENT_TYPING,
    });

    return dispatch({
        type: REQUEST_CLIENT_TYPING,
        [SOCKET]: {
            type: 'EMIT',
            event: 'typing',
            successType: RESPONSE_CLIENT_TYPING,
            errorType: ERROR_CLIENT_TYPING,
        }
    });
};

export const getHistoryAction = (clientId: string, discussionId?: number, before?: string, after?: string, limit?: number) => (dispatch: Dispatch<any>) => {
    const params: any = {
        token: clientId,
    };

    if (after) {
        params.after_date = after;
    }

    if (before) {
        params.before_date = before;
    }

    params.limit = limit || 20;

    dispatch({
        type: REQUEST_HISTORY,
        clientId,
        before,
        after,
        limit,
        discussionId
    });
    params.discussion_id = discussionId;
    return dispatch({
        type: REQUEST_HISTORY,
        [SOCKET]: {
            type: 'EMIT',
            event: 'history',
            data: [params],
            attached: {
                clientId,
                before,
                after,
                limit,
                discussionId
            },
            successType: RECEIVE_HISTORY,
            errorType: ERROR_HISTORY,
        },
    });
};

export const getCounterUnreadMessagesAction = (discussionIds: number[]) => async (dispatch: Dispatch<any>) => {
    dispatch({
        type: REQUEST_GET_COUNTERS,
        discussionIds
    });

    try {
        const body = {
            discussion_ids: discussionIds
        };
        const response = await fetcher(`${CHAT_HOST}/api/v2/client/discussion/counts`)
            .auth(`Basic ${CHAT_KEY}`)
            .post(body)
            .json();

        dispatch({
            type: RESPONSE_GET_COUNTERS,
            response,
        });
    } catch (error) {
        dispatch({
            type: ERROR_GET_COUNTERS,
            error,
        });
    }
};



// WEBPACK FOOTER //
// ./src/actions/chats.ts